import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import theme from '@styles/theme';
import LogoEghis from '@assets/icons/logo_eghis.svg';

import { Image } from '@components/styled/StyledComponents';

const Footer = () => {
    const navigate = useNavigate();
    return (
        <Wrapper>
            <Logo onClick={() => {}}>
                <Image src={LogoEghis} alt="이지스 로고" />
            </Logo>
            <Contents>
                <Menu>
                    <MenuList>이용약관</MenuList>
                    <MenuList>개인정보처리방침</MenuList>
                </Menu>
                <Info>
                    (주)이지스헬스케어 | 대표 김승수 | 사업자등록번호
                    883-87-00463 | 통신판매업신고번호 제2022-서울강서-1405호 |
                    고객센터 1522-2001 | 메일 info@eghishc.com
                </Info>
                <Info>서울시 강서구 마곡중앙5로 22, 웰튼병원 8층</Info>
            </Contents>
            <Copyright>2025 &copy; eghis healthcare</Copyright>
        </Wrapper>
    );
};

export default Footer;

const Wrapper = styled.footer`
    display: flex;
    justify-content: space-between;
    gap: 90px;
    margin: 0 auto;
    width: 1280px;
    height: 180px;
    font-size: 13px;
    font-family: PretendardMedium, sans-serif;
    color: ${theme.colors.lightGrayFontColor};
`;

const Logo = styled.h1`
    height: 16px;
    cursor: pointer;
`;

const Copyright = styled.span`
    color: ${theme.colors.deepGrayFontColor};
`;

const Contents = styled.div`
    flex: 1;
`;

const Menu = styled.nav`
    display: flex;
    gap: 20px;
    margin: 0 0 32px;
`;

const MenuList = styled.button`
    font-size: 13px;
    color: ${theme.colors.deepGrayFontColor};
`;

const Info = styled.div`
    margin-bottom: 14px;
    font-size: 12px;
    color: ${theme.colors.lightGrayFontColor};
`;
